export default __webpack_public_path__ + "static/media/floor-15.b6ee555d.jpg";